import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { PaginaProducao } from '../types/producao.type';

@Injectable({
  providedIn: 'root'
})
export class ProducaoindustrialService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getProducaos(page: number, size: number, filtro?: string){
    let params = new HttpParams()
      .set('page', page)
      .set('size', size);

    if (filtro) {
      params = params.set('filtro', filtro);
    }

    return this.httpClient.get<PaginaProducao>(`${this.configService.getApiUrlRoot()}/producao-industrial-pro/`, { params });
  }
}
